<template>
  <Layout>
    <div class="section content has-text-white">
      <h1>{{ $t('Write MSISDN to login') }}</h1>
      <p><input type="phone" class="input m-sm is-size-4" v-model="phone" style="width:70%">
      <input type="submit" class="m-sm button is-success is-size-4" @click="send" :value="$t('Continue')"></p>
    </div>
  </Layout>
</template>

<script>
import axios from 'axios'
import Layout from '@/layouts/GG'


export default {
  name: 'Login',
  data () {
    return {
      phone: ''
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage) {
      const saleIdArr = window.location.hash.match(/\?saleId=([a-z0-9]+)/)
      if (saleIdArr instanceof Array && saleIdArr.length == 2) {
        window.localStorage.setItem('saleId', saleIdArr[1])
      }

      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'open') {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  methods: {
    send() {
      const msisdn = this.$store.getters.formatMsisdn(this.phone)
      if (msisdn)
        location.replace(`/nth/identify/${ msisdn }`)
    }
  },
  components: {
    Layout
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangGG/Login.vue